module.exports = __webpack_public_path__ + "img/icon-social-bilibili.2054f5af.svg";